<template>
  <div class="flex flex-col right-[13rem] w-[90%] md:w-[400px] static md:absolute -translate-y-[1rem] md:-translate-y-[34rem] bg-GRIS_CLARO_BUSCAR_NEUMATICO rounded-md px-4 pt-5 py-2 gap-4 md:mt-0 z-30">
 
    <p class="text-ROJO_LEON flex justify-center items-center font-bold text-sm md:text-lg">
      <!--<img class="h-2 mx-1 md:items-start" :src="'/img/shared/point-arrow-iconv2.svg'" alt="point-arrow-icon" />-->
    </p>

    <div class="flex flex-col w-full h-auto">
      <OptionsConsultBatteryMeasure @selectedOption="selectedOption" />
    </div>

    <!-- contenedor general inferior -->
    <div>
      <p class="text-ROJO_LEON flex justify-center items-center font-bold text-sm md:text-lg">
        <img class="h-2 mx-1 md:items-start" :src="'/img/shared/point-arrow-iconv2.svg'" alt="point-arrow-icon" />
        Ingresa tu patente y encuentra tu batería
      </p>
      <NeumaticoCurvo v-show="false" />
      
      <!-- CAMBIO: Sin prop selectPlate, solo evento y ref -->
      <InputCarPlate ref="inputCarPlateRef" @changePlate="changePlate" @plateCompleted="onPlateCompleted" />
      <div class="flex flex-col mb-5 items-center pt-1">
        <InputSearch @cambioUbicacion="cambioUbicacion" :searchType="3" :isEnabled="isPlateComplete"
        />
        
        <button :disabled="isDisabledCarComputed || isAddressEmpty || selectedBatteryInstallType === RESCUE" @click="getPlateData" 
          class="mt-4 boton_buscar flex items-center w-[50%] h-10 gap-1 justify-center rounded-md text-white text-sm disabled:opacity-60 bg-VERDE_TOP_CALIDAD"
        >
          <p class="text-base md:text-base font-bold text-white">Buscar</p>
          <LoaderSvg v-if="isDisabledButton" fillColor="currentFill" sizeClass="w-4 h-4 ml-1" />
        </button>
      </div>
    </div>
  </div>

  <ModalError firstButtonText="Aceptar" :show="showErrorModalApi" :message="messageErrorApi" @closeModal="closeErrorModalApi"/>
  
  <ModalConfirm 
  :firstButtonText="'Continuar'" @handleConfirm="changeLocal" 
  :secondButtonText="'Cancelar'" @closeModal="closeModal"  
  :show="isModalVisible"  :message="message" :showActionMessage="false" 
  />
 
  <ModalRescue :show="isModalRescueVisible" @closeModal="closeModalRescue" />
  <ModalNotFoundPlate :show="isModalNotFondPlateVisible" :selectPlate="currentPlate" @closeModal="closeModalNotFoundPlate" @clearPlate="clearPlate" @callContact="callContact" />
</template>

<script setup>
import ModalConfirm from "@/components/Shopping/ModalConfirm.vue";
import ModalError from "@/components/Shopping/Summary/ModalError.vue";

import { useStore } from "vuex";
import LoaderSvg from "~/components/Ui/LoaderSvg";
import InputCarPlate from "~/components/Home/InputCarPlate";
import OptionsConsultBatteryMeasure from "~/components/Home/Battery/OptionsConsultBatteryMeasure";
import ModalRescue from "~/components/Home/Battery/ModalRescue";
import ModalNotFoundPlate from "~/components/Home/Battery/ModalNotFoundPlate";
import NeumaticoCurvo from "~/components/Neumaticos/NeumaticoCurvo.vue";
import { NEGOCIOS } from "~/constants/negocios";

const modo_sistema = useState('modo_sistema');
const store = useStore();
const { 
  products,
  localpivote,
  fullcercano, 
  ubication_confirmed,
  ubication,
  getLocalPivote,
  setLocalPivote,
  setUbicationConfirmed,
  setFullcercano,
  setLocalCambio,
  getProducts,
  getFullcercano,
  getUbication,
  clearCart,
  setUbication,
  setAddress,
  getUbicationConfirmed,
  setBatteryInstallType,
} = useCartBridge();

const config = useRuntimeConfig();

const router = useRouter();
const isModalVisible = ref(false);
const isModalRescueVisible = ref(false);
const isModalNotFondPlateVisible = ref(false);
const RESCUE = 6;
const LOCAL = 5;
const HOME = 4;
const carPlate = useCookie('plate');

// AGREGAR: Variable local para manejar la patente
const currentPlate = ref("");
const inputCarPlateRef = ref(null);

const isPlateComplete = computed(() => {
  if (!currentPlate.value || currentPlate.value.length !== 6) {
    return false;
  }
  return true;
});

const showModalDiff = ref(false);
const message = ref("Si cambias tu ubicación, es posible que te derivemos a un local diferente, pudiendo producirse modificaciones en tu carro de compras, productos, stock o precios.");
const selectedBatteryInstallType = ref(LOCAL);
const oldUbication = ref(null);
const oldfullcercano = ref(null);

const isDisabledButton = ref(false);
const isAddressEmpty = ref(ubication.value.address == "");

const showErrorModalApi = ref(false);
const messageErrorApi = ref("Ha ocurrido un inconveniente");
const closeErrorModalApi = () => {
  showErrorModalApi.value = false;
};

const props = defineProps({
  category: {
    type: String,
    required: false,
    default: "",
  },
});

const emit = defineEmits(["callContact"]);

const cambioUbicacion = (value, type) => {
  if (ubication.value.address != value) {
    changeAddressEmpty(true, type);
  } else {
    changeAddressEmpty(false, type);
  }
};

const changeAddressEmpty = (value, type) => {
  isAddressEmpty.value = value;
};

const onPlateCompleted = () => {
  // Esperar un poco para que se actualice el estado isEnabled
  setTimeout(() => {
    const targetInput = document.querySelector('.resaltar_programatico');
    if (targetInput && !targetInput.disabled) {
      targetInput.focus();
    }
  }, 10);
};

const changePlate = (value) => {
  //console.log("debug_03_06_2025 -> changePlate(); value: ", value);
  currentPlate.value = value;
};

const clearPlate = () => {
  //console.log("debug_03_06_2025 -> clearPlate();");
  currentPlate.value = "";
  inputCarPlateRef.value?.clearPlate();
  closeModalNotFoundPlate();
};

const callContact = () => {
  closeModalNotFoundPlate();
  emit("callContact");
};

const changeLocal = async () => {
  oldfullcercano.value = null;
  oldUbication.value = null;
  isModalVisible.value = false;
  showModalDiff.value = false;
  setLocalCambio(true);
  clearCart();
  getPlateData();
};

const closeModal = () => {
  setUbication(ubication_confirmed.value);
  setLocalPivote(fullcercano.value);
  setLocalCambio(false);
  isModalVisible.value = false;
  showModalDiff.value = false;
};

const closeModalRescue = () => {
  isModalRescueVisible.value = false;
};

const closeModalNotFoundPlate = () => {
  isModalNotFondPlateVisible.value = false;
};

const selectedOption = (value) => {
  selectedBatteryInstallType.value = value;
  if (value == RESCUE) {
    isModalRescueVisible.value = true;
  }
};

const getPlateData = async () => {
  try {
    if (!showModalDiff.value) {
      setUbicationConfirmed(ubication.value);
      store.commit("plpModule/updateProducts", []);
      store.commit("plpModule/updateFilterProducts", []);
      setFullcercano(localpivote.value);
      setBatteryInstallType(selectedBatteryInstallType.value);

      const mappedAddress = {
        region: ubication.value.region,
        commune: ubication.value.commune,
        address: ubication.value.address,
        details: "",
        comments: "",
        latitude: ubication.value.latitude,
        longitude: ubication.value.longitude,
      };
      setAddress(mappedAddress);

      carPlate.value = currentPlate.value;
      router.push(`/${modo_sistema.value}/plp/${currentPlate.value}`);
    } else {
      {
        isModalVisible.value = true;
        isDisabledButton.value = false;
      }
    }
  } catch (error) {
    if (error.response.status === 404) {
      isModalNotFondPlateVisible.value = true;
    }
  }
};

const { isDisabledCar } = UseBatteryMeasure();

const isDisabledCarComputed = computed(() => {
  return isDisabledCar(currentPlate.value);
});

const loadChargedData = () => { };

onMounted(() => {
  getProducts();
  getFullcercano();
  getLocalPivote();
  getUbication();
  getUbicationConfirmed();
});

watch(() => ubication.value, (newValue, oldValue) => {
  oldUbication.value = oldValue;
  if (
    isModalVisible.value &&
    oldValue.address != "" &&
    oldUbication.value.address != ubication.value.address &&
    products.value.length > 0
  ) {
    oldUbication.value = oldValue;
  }
});

watch(() => localpivote, (newPivote) => {
  if (newPivote && fullcercano.value && products.value.length > 0) {
    const cambiolocal = newPivote.local_id !== fullcercano.value.local_id;
    if (cambiolocal) {
      showModalDiff.value = true;
      oldfullcercano.value = fullcercano.value;
    } else {
      showModalDiff.value = false;
    }
  }
},{ deep: true });

</script>

<style scoped>
.boton_buscar:disabled{
  background-color: rgb(209 209 209);
  color: black;
}
</style>